import { TitleSection } from 'components/generic';
import { useState } from 'react';
import Images from 'assets/Images';

import './style.scss';

const Tutorial = () => {
	const [playVideos, setplayVideos] = useState(false);

	return (
		<>
			<div className='tutorial__header'>
				<img src={Images.loginLogo} alt='App logo' width='30px' height='30px' />
				<h4>Client Portal</h4>
			</div>
			{!playVideos && (
				<div className='tutorial'>
					<TitleSection title='Tutorial-Videos' count={null} search />
					<div className='row'>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson-1 How to make the required software</p>
						</div>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson 2 : How to know the required template format</p>
						</div>
						<div className='tutorial__video3' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson 3 : What are the requirements in our system</p>
						</div>
					</div>
					<div className='row'>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson 4 : Lorem Ipsum has been the industry’s standard dummy text….</p>
						</div>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson 5 : Lorem Ipsum has been the industry’s stand</p>
						</div>
						<div className='tutorial__video3' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson 6 : How to learn the required software in 5 steps</p>
						</div>
					</div>
					<div className='row'>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson-1 How to make the required software</p>
						</div>
						<div className='tutorial__videos' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson-1 How to make the required software</p>
						</div>
						<div className='tutorial__video3' onClick={() => setplayVideos(true)}>
							<div className='tutorial__videos__content'></div>
							<p>Lesson-1 How to make the required software</p>
						</div>
					</div>
				</div>
			)}

			{playVideos && (
				<div className='tutorial'>
					<h4>Tutorial-Videos</h4>
					<div className='tutorial__play-videos'>
						<div className='tutorial__play'></div>
						<h5>Lesson 1 : How to start the required software</h5>
						<p>Lorem ipsum is a name for a common type of placeholder text. Also known as filler or dummy text, this is text copy that serves to fill a space without saying</p>
						<hr></hr>
						<h5>Related Videos Are</h5>
						<div className='row'>
							<div className='tutorial__related-videos'>
								<div className='tutorial__related-videos__content'></div>
								<p>Lesson-1 How to make the required software</p>
							</div>
							<div className='tutorial__related-videos'>
								<div className='tutorial__related-videos__content'></div>
								<p>Lesson-1 How to make the required software</p>
							</div>
							<div className='tutorial__related-videos'>
								<div className='tutorial__related-videos__content'></div>
								<p>Lesson-1 How to make the required software</p>
							</div>
							<div className='tutorial__related-videos--last'>
								<div className='tutorial__related-videos__content'></div>
								<p>Lesson-1 How to make the required software</p>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Tutorial;
